// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-image-crop/dist/ReactCrop.css
// module id = 1984
// module chunks = 0